import { AccessRightLevelEnum, ItemMenu } from '@osos/shared/types';

export const ADMIN_MENU_ITEMS = [
  {
    label: 'base.menu.Administration',
    icon: 'pi pi-wrench',
    permissionLevel: AccessRightLevelEnum.ViewAccess,
    id: 'baseMenuAdministration',
    iconClass: 'color-primary',
    items: [
      {
        label: 'base.menu.Spaces',
        icon: 'PMO-icon-xnix-Planet',
        routerLink: `/admin/spaces`,
        permissionLevel: AccessRightLevelEnum.AdminAccess,
        id: 'baseMenuSpaces',
        type: 'internal',
      },
      {
        label: 'base.menu.Interfaces',
        icon: 'icon-managerial',
        permissionLevel: AccessRightLevelEnum.DeveloperAccess,
        id: 'baseMenuInterfaces',
        items: [
          {
            label: 'base.menu.TEMPLATES',
            icon: 'PMO-icon-note-text',
            routerLink: `/admin/templates`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuTemplates',
            type: 'internal',
          },
          {
            label: 'base.menu.LANGUAGES',
            icon: 'PMO-icon-xnix-Language',
            routerLink: `/admin/languages`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuLanguages',
            type: 'internal',
          },
          {
            label: 'base.menu.FONTS',
            icon: 'PMO-icon-note-text',
            routerLink: `/admin/fonts`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuFonts',
            type: 'internal',
          },
          {
            label: 'base.menu.THEMES',
            icon: 'PMO-icon-hicon-Color-Picker',
            routerLink: `/admin/themes`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuThemes',
            type: 'internal',
          },

          {
            label: 'base.menu.TIMEZONES',
            icon: 'PMO-icon-hicon-Time-Circle-2',
            routerLink: `/admin/timezone`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuTimezone',
            type: 'internal',
          },
          {
            label: 'base.menu.SETTINGS',
            icon: 'PMO-icon-hicon-Setting',
            routerLink: `/admin/settings`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuSettings',
            type: 'internal',
          },
        ],
      },

      {
        label: 'base.menu.APPS',
        icon: 'icon-managerial',
        permissionLevel: AccessRightLevelEnum.ViewAccess,
        id: 'baseMenuApps',
        items: [
          {
            label: 'base.menu.Modules',
            icon: 'icon-events',
            routerLink: '/admin/modules',
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuModules',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.DataEntity',
            icon: 'icon-icon-open-task',
            routerLink: '/admin/entities',
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuDataEntity',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.Collections',
            icon: 'PMO-icon-xnix-Playlist',
            routerLink: '/admin/collections',
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuCollections',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.FUNCTIONS',
            icon: 'PMO-icon-xnix-Code',
            routerLink: `/admin/functions`,
            permissionLevel: AccessRightLevelEnum.AdminAccess,
            id: 'baseMenuFunctions',
            type: 'internal',
          },
          {
            label: 'base.menu.PAGES',
            icon: 'PMO-icon-xnix-Dashboard_2',
            routerLink: `/admin/pages`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuPages',
            type: 'internal',
          },
          {
            label: 'base.menu.VIEWS',
            icon: 'PMO-icon-xnix-map_paper',
            routerLink: `/admin/views`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuViews',
            type: 'internal',
          },
          {
            label: 'base.menu.DASHBOARDS',
            icon: 'PMO-icon-xnix-Dashboard-4',
            routerLink: '/admin/dashboard',
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuDashboard',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.Counters',
            icon: 'icon-public',
            routerLink: `/admin/counters`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuCounters',
            type: 'internal',
          },
        ],
      },
      // TODO: Change the icons when they are available
      {
        label: 'base.menu.MONITORING',
        icon: 'icon-managerial',
        permissionLevel: AccessRightLevelEnum.AdminAccess,
        id: 'baseMonitoring',
        items: [
          {
            label: 'base.menu.LOGS',
            icon: 'icon-events',
            routerLink: '/admin/monitoring/logs',
            permissionLevel: AccessRightLevelEnum.AdminAccess,
            id: 'baseMenuLogs',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.SYSTEM_LOGS',
            icon: 'icon-events',
            routerLink: '/admin/monitoring/system-logs',
            permissionLevel: AccessRightLevelEnum.AdminAccess,
            id: 'baseMenuSystemLogs',
            items: [],
            type: 'internal',
          },
          {
            label: 'base.menu.AUDIT_LOGS',
            icon: 'icon-events',
            routerLink: '/admin/monitoring/audit',
            permissionLevel: AccessRightLevelEnum.AdminAccess,
            id: 'baseMenuAudit',
            items: [],
            type: 'internal',
          },
        ],
      },

      {
        label: 'base.menu.Services',
        icon: 'icon-services',
        permissionLevel: AccessRightLevelEnum.DeveloperAccess,
        id: 'baseMenuServices',
        items: [
          {
            label: 'base.menu.SERVICE_CATALOG',
            icon: 'icon-services-catalog',
            routerLink: `/admin/services`,
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuServiceCatalog',
            type: 'internal',
          },
          {
            label: 'base.menu.REQUESTS_LIST',
            icon: 'icon-services',
            routerLink: '/admin/requests',
            permissionLevel: AccessRightLevelEnum.DeveloperAccess,
            id: 'baseMenuAllRequests',
            type: 'internal',
          },
        ],
      },
      {
        label: 'base.menu.ORGANIZATION',
        icon: 'icon-organization',
        permissionLevel: AccessRightLevelEnum.AdminAccess,
        id: 'baseMenuOrganization',
        items: [
          {
            label: 'base.menu.GROUPS',
            icon: 'icon-pick-user-group',
            routerLink: `/admin/groups`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuGroups',
            type: 'internal',
          },
          {
            label: 'base.menu.USERS_GROUPs',
            icon: 'icon-pick-user-group',
            routerLink: `/admin/users_groups`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuUsers',
            type: 'internal',
          },
          {
            label: 'base.menu.QUERY_GROUPS',
            icon: 'icon-pick-user-group',
            routerLink: `/admin/query_groups`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuUsers',
            type: 'internal',
          },
          {
            label: 'base.menu.USERS',
            icon: 'icon-user',
            routerLink: `/admin/users`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuUsers',
            type: 'internal',
          },
          {
            label: 'base.menu.ROLES',
            icon: 'icon-administration',
            routerLink: `/admin/roles`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuRoles',
            type: 'internal',
          },
          {
            label: 'base.menu.ORG_CHART',
            icon: 'icon-module',
            routerLink: `/admin/org-chart`,
            permissionLevel: AccessRightLevelEnum.ViewAccess,
            id: 'baseMenuOrgChart',
            type: 'internal',
          },
        ],
      },
      {
        label: 'base.menu.AccessPermissions',
        icon: 'icon-administration',
        routerLink: '/admin/system/permissions',
        permissionLevel: AccessRightLevelEnum.AdminAccess,
        id: 'access-permissions',
        type: 'internal',
      },
    ],
  },
] satisfies ItemMenu[];

export enum PublicMenuItemsEnum {
  ServiceCatalog = 'baseServiceMenuServiceCatalog',
  Inbox = 'baseServiceMenuInbox',
  Request = 'baseServiceMenuMyRequests',
  RequestMonitoring = 'baseServiceMenuRequestMonitoring',
}

export const PUBLIC_SERVICES_MENU_ITEMS = [
  {
    label: 'base.menu.SERVICES',
    icon: 'icon-services',
    styleClass: 'showOnHover',
    id: 'baseServiceAdministration',
    iconClass: 'color-primary',
    items: [
      {
        label: 'base.menu.SERVICE_CATALOG',
        icon: 'icon-services-catalog',
        routerLink: `/s`,
        id: PublicMenuItemsEnum.ServiceCatalog,
        type: 'internal',
      },
      {
        label: 'base.menu.MY_REQUESTS',
        icon: 'icon-my-request-outbox',
        routerLink: `/my`,
        id: PublicMenuItemsEnum.Request,
        type: 'internal',
      },
      {
        label: 'base.menu.INBOX',
        icon: 'icon-inbox',
        routerLink: `/inbox`,
        id: PublicMenuItemsEnum.Inbox,
        type: 'internal',
      },
      {
        label: 'base.menu.REQUEST_MONITORING',
        icon: 'icon-request-monitoring',
        routerLink: `/rm`,
        id: PublicMenuItemsEnum.RequestMonitoring,
        type: 'internal',
      },
    ],
  },
] satisfies ItemMenu[];
